const APARTMENT = 'apartment';
const CARAVAN_SITE = 'caravanSite';
const COTTAGE = 'cottage';

const getRoomType = (roomName) => {
	const roomNameLowerCase = roomName.toLowerCase();

	if (roomNameLowerCase.includes('apartman') || roomNameLowerCase.includes('apartmán')) {
		return APARTMENT;
	} else if (roomNameLowerCase.includes('chalupa')) {
		return COTTAGE;
	} else {
		return null;
	}
};

export default {
	APARTMENT,
	CARAVAN_SITE,
	COTTAGE,

	getRoomType,
}


// WEBPACK FOOTER //
// ./src/enums/RoomType.js